export enum AnalyticType {
  SOWING = 'sowing',
  WEEDS = 'weeds',
  SAT_NEMATODES = 'sat-nematodes',
  SAT_HARVEST = 'sat-harvest',
  SAT_PIXEL_ANOMALY = 'sat-pixel-anomaly',
  SAT_SUGAR = 'sat-sugar',
  SAT_SOIL_MOISTURE = 'sat-soil-moisture',
  FLOWERING = 'flowering',
  LAND_USE = 'land-use',
  DEFORESTATION = 'deforestation'
}
